export const pageTitle = title => {
  return (document.title =
    title + ' | Starbright ABA | Harriman, NY & Newburgh, NY');
};
